let Booking = (function () {
  const prefix = "okkami_webstore";
  let setData = function (bookingNumber, data) {
    localStorage.setItem(
      `${prefix}_booking_${bookingNumber}`,
      JSON.stringify(data)
    );
  };
  const getData = (bookingNumber) => {
    return JSON.parse(
      localStorage.getItem(`${prefix}_booking_${bookingNumber}`)
    );
  };

  let setGuests = function (bookingNumber, data) {
    localStorage.setItem(
      `${prefix}_guests_${bookingNumber}`,
      JSON.stringify(data)
    );
  };
  const getGuests = (bookingNumber) => {
    return JSON.parse(
      localStorage.getItem(`${prefix}_guests_${bookingNumber}`)
    );
  };

  let setResultBooking = function (bookingNumber, data) {
    localStorage.setItem(
      `${prefix}_result_booking_${bookingNumber}`,
      JSON.stringify(data)
    );
  };
  const getResultBooking = (bookingNumber) => {
    return JSON.parse(
      localStorage.getItem(`${prefix}_result_booking_${bookingNumber}`)
    );
  };

  let setResultProperty = function (propertyUid, data) {
    localStorage.setItem(
      `${prefix}_result_property_${propertyUid}`,
      JSON.stringify(data)
    );
  };
  const getResultProperty = (propertyUid) => {
    return JSON.parse(
      localStorage.getItem(`${prefix}_result_property_${propertyUid}`)
    );
  };

  let setResultGuestService = function (propertyUid, data) {
    localStorage.setItem(
      `${prefix}_result_guest_service_${propertyUid}`,
      JSON.stringify(data)
    );
  };
  const getResultGuestService = (propertyUid) => {
    return JSON.parse(
      localStorage.getItem(`${prefix}_result_guest_service_${propertyUid}`)
    );
  };

  let setResultRoomPreset = function (propertyUid, data) {
    localStorage.setItem(
      `${prefix}_result_room_preset_${propertyUid}`,
      JSON.stringify(data)
    );
  };
  const getResultRoomPreset = (propertyUid) => {
    return JSON.parse(
      localStorage.getItem(`${prefix}_result_room_preset_${propertyUid}`)
    );
  };

  let setCard = function (bookingNumber, data) {
    localStorage.setItem(
      `${prefix}_card_${bookingNumber}`,
      JSON.stringify(data)
    );
  };
  const getCard = (bookingNumber) => {
    return JSON.parse(localStorage.getItem(`${prefix}_card_${bookingNumber}`));
  };

  let setBookingDetailUrl = function (url) {
    localStorage.setItem(`${prefix}_booking_detail_url`, JSON.stringify(url));
  };
  const getBookingDetailUrl = () => {
    return JSON.parse(localStorage.getItem(`${prefix}_booking_detail_url`));
  };

  let setUpcomingStays = function (upcoming_stays) {
    localStorage.setItem(
      `${prefix}_upcoming_stays`,
      JSON.stringify(upcoming_stays)
    );
  };
  const getUpcomingStays = () => {
    return JSON.parse(localStorage.getItem(`${prefix}_upcoming_stays`));
  };

  let setServiceToken = function (bookingNumber, data) {
    localStorage.setItem(
      `${prefix}_serviceToken_${bookingNumber}`,
      JSON.stringify(data)
    );
  };
  const getServiceToken = (bookingNumber) => {
    return JSON.parse(
      localStorage.getItem(`${prefix}_serviceToken_${bookingNumber}`)
    );
  };

  let setPaymentTransactionID = function (bookingNumber, data) {
    localStorage.setItem(`${prefix}_paymentTransaction_${bookingNumber}`, data);
  };
  const getPaymentTransactionID = (bookingNumber) => {
    return localStorage.getItem(
      `${prefix}_paymentTransaction_${bookingNumber}`
    );
  };

  let setUserToken = function (proeprtyUid, token) {
    if (token) {
      localStorage.setItem(`${prefix}_userToken_${proeprtyUid}`, token);
    } else {
      localStorage.removeItem(`${prefix}_userToken_${proeprtyUid}`);
    }
  };
  const getUserToken = (proeprtyUid) => {
    return localStorage.getItem(`${prefix}_userToken_${proeprtyUid}`);
  };

  let setOAuthToken = function (proeprtyUid, token) {
    if (token) {
      localStorage.setItem(`${prefix}_accessToken_${proeprtyUid}`, token);
    } else {
      localStorage.removeItem(`${prefix}_accessToken_${proeprtyUid}`);
    }
  };
  const getOAuthToken = (proeprtyUid) => {
    return localStorage.getItem(`${prefix}_accessToken_${proeprtyUid}`);
  };

  let setUserEmail = function (proeprtyUid, email) {
    if (email) {
      localStorage.setItem(`${prefix}_userEmail_${proeprtyUid}`, email);
    } else {
      localStorage.removeItem(`${prefix}_userEmail_${proeprtyUid}`);
    }
  };
  const getUserEmail = (proeprtyUid) => {
    return localStorage.getItem(`${prefix}_userEmail_${proeprtyUid}`);
  };

  return {
    getData: getData,
    setData: setData,
    setGuests: setGuests,
    getGuests: getGuests,
    setResultBooking: setResultBooking,
    getResultBooking: getResultBooking,
    setResultProperty: setResultProperty,
    getResultProperty: getResultProperty,
    setResultGuestService: setResultGuestService,
    getResultGuestService: getResultGuestService,
    setResultRoomPreset: setResultRoomPreset,
    getResultRoomPreset: getResultRoomPreset,
    setCard: setCard,
    getCard: getCard,
    setBookingDetailUrl: setBookingDetailUrl,
    getBookingDetailUrl: getBookingDetailUrl,
    setUpcomingStays: setUpcomingStays,
    getUpcomingStays: getUpcomingStays,
    getServiceToken: getServiceToken,
    setServiceToken: setServiceToken,
    getPaymentTransactionID: getPaymentTransactionID,
    setPaymentTransactionID: setPaymentTransactionID,
    getUserToken: getUserToken,
    setUserToken: setUserToken,
    getOAuthToken: getOAuthToken,
    setOAuthToken: setOAuthToken,
    getUserEmail: getUserEmail,
    setUserEmail: setUserEmail,
  };
})();

export default Booking;
